<div class="mc-dialog-alert mc-spring-board">
  <div class="mc-spring-board-header">
    <mat-icon fontSet="project-titan" fontIcon="icon-alert" class="mc-image-icon mc-image-icon-normal" color="primary"></mat-icon>
    <button type="button" mat-icon-button class="mc-dialog-floating-close-button" color="secondary-invert" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </div>

  <div class="mc-spring-board-body mc-spring-board">
    <div class="mc-spring-board-header">
      <h2 class="mc-dialog-alert-heading">
        <ng-container *ngIf="data.title">{{ data.title }}</ng-container>
        <ng-container *ngIf="data.action">{{ data.action }} Cancelled</ng-container>
      </h2>
    </div>

    <div class="mc-spring-board-body">
      <ng-container *ngIf="successfulMerges?.length > 0">
        <p class="mc-form-section">
          External commits have been merged into the files below:
        </p>

        <mat-list class="mc-list-compact mc-form-section">
          <mat-list-item *ngFor="let mergeResult of successfulMerges">
            <mc-path-list-item [path]="mergeResult.filePath">
              <ng-template mcListItemActions>
                <a href="#" mat-icon-button class="mc-flex-shrink-0" matTooltip="Open File in New Tab" [routerLink]="['/', data.licenseId, 'projects', data.projectId, 'workspace', 'file', data.branchName, mergeResult.filePath]" target="_blank">
                  <mat-icon fontSet="project-titan" fontIcon="icon-launch"></mat-icon>
                </a>
              </ng-template>
            </mc-path-list-item>
          </mat-list-item>
        </mat-list>

        <p class="mc-form-section">
          <b>Your status has been changed to In Progress on the merged files. Please review them before committing again.</b>
        </p>
        <div class="mc-form-spacer"></div>
      </ng-container>

      <ng-container *ngIf="data.conflictResolutionResult?.pendingAdds?.length > 0">
        <p class="mc-form-section">
          The files below were deleted in an external commit. They are now in a pending add state in your workspace.
        </p>

        <mat-list class="mc-list-compact mc-form-section">
          <mat-list-item *ngFor="let mergeResult of data.conflictResolutionResult.pendingAdds">
            <mc-path-list-item [path]="mergeResult.filePath">
              <ng-template mcListItemActions>
                <a href="#" mat-icon-button class="mc-flex-shrink-0" matTooltip="Open File in New Tab" [routerLink]="['/', data.licenseId, 'projects', data.projectId, 'workspace', 'file', data.branchName, mergeResult.filePath]" target="_blank">
                  <mat-icon fontSet="project-titan" fontIcon="icon-launch"></mat-icon>
                </a>
              </ng-template>
            </mc-path-list-item>
          </mat-list-item>
        </mat-list>

        <p class="mc-form-section">
          <b>Your status has been changed to In Progress on these files. Please review them before committing again.</b>
        </p>
        <div class="mc-form-spacer"></div>
      </ng-container>

      <ng-container *ngIf="failedMerges?.length > 0">
        <p class="mc-form-section">
          External commits could not be merged for the following files:
        </p>
        <mat-list class="mc-list-compact mc-list-wrap mc-form-section">
          <mat-list-item *ngFor="let mergeResult of failedMerges">
            <mc-path-list-item [path]="mergeResult.filePath">
              <ng-template mcListItemActions>
                &nbsp;
                <mat-icon class="mc-image-icon mc-flex-shrink-0 mc-flex-grow-0" color="warn" fontSet="project-titan" fontIcon="icon-error" matTooltip="Merge failed"></mat-icon>
              </ng-template>
              <ng-template mcListItemLine>
                <p class="mc-text-warn">
                  {{ mergeResult.error?.message }}
                </p>
              </ng-template>
            </mc-path-list-item>
          </mat-list-item>
        </mat-list>

        <p class="mc-form-section">
          <b>Please correct these files in an external commit before committing again.</b>
        </p>
        <div class="mc-form-spacer"></div>
      </ng-container>
    </div>
  </div>

  <div class="mc-spring-board-form-footer">
    <div class="mc-form-buttons">
      <button type="submit" mat-raised-button color="primary" (click)="closeDialog()">Dismiss</button>
    </div>
  </div>
</div>